import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./routes/Home";
import Lenis from "@studio-freight/lenis";
import { useEffect } from "react";
import Footer from "./components/Footer";
import Academy from "./routes/Academy";
import ProgramDetail from "./routes/ProgramDetails";
import AboutUs from "./routes/AboutUs";
import Login from "./routes/Login";
import Signup from "./routes/Signup";
import Enroll from "./routes/Enroll";
import ProtectedRoute from "./components/ProtectedRoute";
import Contact from "./routes/Contact";
import LegalPage from "./routes/LegalPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2, // scroll smoothness (higher = smoother)
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // buttery easing
      smoothWheel: true,
      smoothTouch: false, // usually false for mobile
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/academy/:id" element={<ProgramDetail />} />
        <Route
          path="/enroll/:id"
          element={
            <ProtectedRoute>
              <Enroll />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-conditions" element={<LegalPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
